"use client"

import { cn } from "@/lib/utils"

export interface LegalListItem {
  title?: string
  description?: string
}

export interface LegalListSection {
  subheadline?: string
  items?: LegalListItem[]
  footerNote?: string
}

interface LegalItemsListProps {
  title?: string
  subtitle?: string;
  description?: string
  lists?: LegalListSection[]
  footerNote?: string
  className?: string
  grid?: boolean
}

export function LegalItemsList({
  title,
  description,
  lists = [],
  footerNote,
  className,
  subtitle,
  grid = true
}: LegalItemsListProps) {
  return (
    <div className={cn("w-full", className)}>
      {/* Title */}
      {title && (
        <h3 className="text-fb-primary text-3xl font-bold mb-2">{title}</h3>
      )}
      {/* Subtitle */}
      {subtitle && (
        <h4 className="text-xl font-base text-slate-900 mb-2">{subtitle}</h4>
      )}
      {/* Description */}
      {description && (
        <p className="text-base text-slate-900 mb-4">{description}</p>
      )}

      {/* Lists */}
      {lists.length > 0 && (
        <div className={cn(
          "flex flex-col gap-8",
          grid ? "xl:flex-row xl:gap-12" : ""
        )}>
          {lists.map((list, idx) => (
            <div key={idx} className="flex-1 space-y-4">
              {list.subheadline && (
                <h4 className="text-xl font-base text-slate-900 mb-2">{list.subheadline}</h4>
              )}
              {list.items && (
                <ul className="space-y-3 list-disc xl:ml-8 ml-4">
                  {list.items.map((item, itemIdx) => (
                    <li key={itemIdx}>
                      {item.title && (
                        <span className="font-bold text-base text-slate-900">{item.title}</span>
                      )}
                      {item.description && (
                        <p className="text-base font-thin text-slate-900 mt-1">{item.description}</p>
                      )}
                    </li>
                  ))}
                </ul>
              )}
              {list.footerNote && (
                <p className="text-base text-slate-900">{list.footerNote}</p>
              )}
            </div>
          ))}
        </div>
      )}

      {/* Footer Note */}
      {footerNote && (
        <div className="mt-6">
          <p className="text-base text-slate-900">{footerNote}</p>
        </div>
      )}
    </div>
  )
}